import React, { FC, useContext } from "react";
import {
  AppContext,
  InlineMultipleRowsProps,
  View,
  useAppContext,
  useClientContext,
  useInlineContext,
  useNavigation,
  useHeaders,
  withGroups,
} from "@data-root/react";
import {
  FormulaContext,
  GalleryView,
  RowWithEmbeddedMetadata,
} from "@data-root/types";
import { useAsyncCallback } from "@data-root/react";
import { Button, List, Image, Typography } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";

interface GalleryItemProps {
  getContext: () => FormulaContext;
  row: RowWithEmbeddedMetadata;
}

const { Text } = Typography;

export const GalleryItem: FC<GalleryItemProps> = ({ getContext, row }) => {
  const { core } = useClientContext();
  const { appSpecifier } = useAppContext();
  const inlineContext = useInlineContext();
  const { navigation } = useNavigation();

  const { view } = inlineContext;
  const { options } = view as GalleryView;
  const { id: rowId } = row;
  const { primaryHeader: primaryHeaderId, image: imageId } = options;

  const { primaryHeader, imageUri } = useHeaders(
    // appSpecifier,
    // view.tableId,
    getContext,
    row,
    primaryHeaderId,
    null,
    imageId
  );

  const onClick = useAsyncCallback(async () => {
    if (!options.onClick) return;

    const onClick = await core.evaluateFormula<string>(options.onClick, {
      appId: appSpecifier.appId,
      deploymentId: appSpecifier.deploymentId,
      row,
    });

    navigation.navigate(onClick, { rowId });
  }, [
    options.onClick,
    core,
    appSpecifier.appId,
    appSpecifier.deploymentId,
    row,
    navigation,
    rowId,
  ]);

  return (
    <View style={stylesheet.container}>
      <Image style={stylesheet.image} src={imageUri} />

      <Text style={stylesheet.text}>{primaryHeader}</Text>
    </View>
  );
};

export const GalleryItemPlaceholder: FC = () => {
  return null;
};

export const GalleryItemsSkeleton: FC = () => {
  return null;
};

export const gridConfig = {
  gutter: 16,
  xs: 1,
  sm: 2,
  md: 3,
  lg: 4,
  xl: 5,
  xxl: 6,
};

export const GalleryItems: FC<InlineMultipleRowsProps> = withGroups(
  ({ getContext, containerId, rows, onFetch, loaded, fetching, totalRows }) => {
    const { styles } = useContext(AppContext)!;

    if (!loaded) return <GalleryItemsSkeleton />;

    return (
      <InfiniteScroll
        dataLength={rows.length}
        next={onFetch}
        hasMore={rows.length < totalRows}
        loader={null}
        scrollableTarget={containerId}
      >
        <List
          split={false}
          grid={gridConfig}
          dataSource={rows}
          rowKey={(row) => row.id}
          renderItem={(row) => {
            const getExtendedContext = () => ({
              ...getContext(),
              row: row,
              rowId: row.id,
            });

            return (
              <List.Item>
                <GalleryItem getContext={getExtendedContext} row={row} />
              </List.Item>
            );
          }}
          footer={
            rows.length < totalRows && onFetch ? (
              <Button
                type="link"
                onClick={onFetch}
                style={{
                  color: styles.primaryColor,
                }}
                loading={fetching}
              >
                Cargar más
              </Button>
            ) : undefined
          }
        />
      </InfiniteScroll>
    );
  }
);

const stylesheet = {
  container: {
    flex: 1,

    padding: 10,
    gap: 10,

    backgroundColor: "#eee",
  },
  imageContainer: {},
  image: {
    height: "100%",
    aspectRatio: 1,
    resizeMode: "cover",
  },
  text: {},
  grid: {
    gap: 10,
  },
};
